/**
 * KAN-834: вкладка "Внимание" приложения менеджера: клиенты, которым сейчас
 * нужен человек (свои и ничьи по правилам backend), все каналы сразу.
 * KAN-851: чипы фильтра по теплоте лида.
 * KAN-926: разделы списка (attention_section), число раздела после фильтра теплоты.
 * KAN-868: плашка про уведомления переехала в MobileLayout (KAN-873: строка MobileSetupChips).
 * KAN-956: над списком раздел "Встречи и перезвоны на сегодня" (тот же компонент, что на дашборде).
 * KAN-964: раздел переехал во вкладку "Встречи"; здесь одна строка-ссылка с числом на сегодня.
 */
import { Loader2, RefreshCw } from 'lucide-react';
import { AttentionSections } from '@/components/attention/AttentionSections';
import { MobileAttentionCard } from '@/components/mobile/MobileAttentionCard';
import { MobileTemperatureChips } from '@/components/mobile/MobileTemperatureChips';
import { TodayStepsLink } from '@/components/todaySteps/TodayStepsLink';
import { useMobileAttention } from '@/hooks/useMobileData';

export function MobileAttentionPage(): JSX.Element {
  const { all, items, temperature, data, isLoading, isError, isFetching, refetch } = useMobileAttention();
  // KAN-926: числа разделов backend по всему списку; с фильтром теплоты считаем по отфильтрованным.
  const sectionCounts = temperature.filter === 'all' ? data?.section_counts : null;

  return (
    <section className="px-4 py-4" data-testid="mobile-attention-page">
      <TodayStepsLink className="mb-4" />
      <header className="mb-3 flex items-center justify-between">
        <h1 className="text-xl font-semibold text-gray-900">Требуют внимания</h1>
        <button
          type="button"
          onClick={() => void refetch()}
          disabled={isFetching}
          aria-label="Обновить"
          className="flex h-11 w-11 items-center justify-center rounded-full text-gray-600 active:bg-gray-200 disabled:opacity-50"
        >
          <RefreshCw className={`h-5 w-5 ${isFetching ? 'animate-spin' : ''}`} aria-hidden="true" />
        </button>
      </header>
      <MobileTemperatureChips value={temperature.filter} onChange={temperature.setFilter} />
      {isLoading && (
        <div className="flex justify-center py-12">
          <Loader2 className="h-6 w-6 animate-spin text-gray-400" aria-label="Загрузка" />
        </div>
      )}
      {isError && <p className="py-8 text-center text-sm text-red-600">Не удалось загрузить список</p>}
      {!isLoading && !isError && items.length === 0 && (
        <p className="py-12 text-center text-sm text-gray-500">
          {all.length > 0 ? 'С такой теплотой никого нет' : 'Сейчас ничего не требует внимания'}
        </p>
      )}
      <AttentionSections
        items={items}
        sectionOf={(item) => item.attention_section}
        counts={sectionCounts}
        renderItems={(group) => (
          <ul className="space-y-3">
            {group.map((item) => (
              <MobileAttentionCard key={item.client_id} item={item} />
            ))}
          </ul>
        )}
      />
    </section>
  );
}
